import get from "lodash/get";

export const DEFAULT_ROLES = ['default-roles-iot_in_box', 'offline_access', 'uma_authorization'];

export const DEFAULT_ROLES_ACCESS = [
  { id: 1, object_name: 'site/levels', read: 0, create: 0, update: 0, delete: 0, approver: 0 },
  { id: 2, object_name: 'things/services', read: 0, create: 0, update: 0, delete: 0, approver: 0 },
  { id: 3, object_name: 'things/components', read: 0, create: 0, update: 0, delete: 0, approver: 0 },
  { id: 4, object_name: 'site/master', read: 0, create: 0, update: 0, delete: 0, approver: 0 },
  { id: 5, object_name: 'things/machines', read: 0, create: 0, update: 0, delete: 0, approver: 0, route_id: 'things_machines' },
  { id: 6, object_name: 'things/machinesbulk', read: 0, create: 0, update: 0, delete: 0, approver: 0 },
  { id: 7, object_name: 'things/parts', read: 0, create: 0, update: 0, delete: 0, approver: 0, route_id: 'things_parts' },
  { id: 8, object_name: 'things/partsbulk', read: 0, create: 0, update: 0, delete: 0, approver: 0 },
  { id: 9, object_name: 'things/gateways', read: 0, create: 0, update: 0, delete: 0, approver: 0, route_id: 'things_gateways' },
  { id: 10, object_name: 'site/factory', read: 0, create: 0, update: 0, delete: 0, approver: 0, route_id: 'site_factory' },
  { id: 11, object_name: 'build_deploy/use_cases', read: 0, create: 0, update: 0, delete: 0, approver: 0 },
  { id: 12, object_name: 'auth/users', read: 0, create: 0, update: 0, delete: 0, approver: 0 },
  { id: 13, object_name: 'auth/roles', read: 0, create: 0, update: 0, delete: 0, approver: 0 },
  { id: 14, object_name: 'tenant/settings', read: 0, create: 0, update: 0, delete: 0, approver: 0 },
  { id: 15, object_name: 'digital_twin/twin', read: 0, create: 0, update: 0, delete: 0, approver: 0 },
  // { id: 15, object_name: 'digital_twin/twin', read: 0, create: 0, update: 0, delete: 0, approver: 0 },
  { id: 16, object_name: 'things/connectivity_dashboard', read: 0, create: 0, update: 0, delete: 0, approver: 0 },
  { id: 17, object_name: 'maintenance', read: 0, create: 0, update: 0, delete: 0, approver: 0, route_id: 'maintenance' },
  { id: 18, object_name: 'secrets', read: 0, create: 0, update: 0, delete: 0, approver: 0, route_id: 'secrets_manager' },
  { id: 19, object_name: 'use_case', read: 0, create: 0, update: 0, delete: 0, approver: 0, route_id: 'use_case_management' },
  { id: 20, object_name: 'grafana_dashboards', read: 0, create: 0, update: 0, delete: 0, approver: 0,route_id: 'grafana_dashboards'  },
];

// export const DEFAULT_FEATURE_TITLES: any = {
//   'build_deploy/use_cases': 'Build and Deploy Use Case',
//   'site/levels': 'Ontology Level Master',
//   'site/master': 'Ontology Management',
//   'site/factory': 'Shop Floor Configuration',
//   'things/services': 'Integration Services Master',
//   'things/components': 'Component Master',
//   'things/machines': 'Machinery Management',
//   'things/machinesbulk': 'Machinery Management / Import',
//   'things/parts': 'Machinery Management / Parts',
//   'things/partsbulk': 'Machinery Management / Parts / Import',
//   'things/gateways': 'Gateways Management',
//   'auth/users': 'User Management / User Access Control',
//   'auth/roles': 'User Management / User Role Access Control',
//   'tenant/settings': 'Settings',
// };

export const DEFAULT_FEATURE_TITLES: any = {
  'build_deploy/use_cases': 'Build and Deploy Use Case',
  'site/levels': 'Ontology Level Master',
  'site/master': 'Ontology Management',
  'site/factory': 'Shop Floor Configuration',
  'things/services': 'Integration Services Master',
  'things/components': 'Component Master',
  'things/machines': 'Machinery Management',
  'things/machinesbulk': 'Import',
  'things/parts': 'Parts',
  'things/partsbulk': 'Import',
  'things/gateways': 'Gateways Management',
  'auth/users': 'User Management / User Access Control',
  'auth/roles': 'User Management / User Role Access Control',
  'tenant/settings': 'Settings',
  'digital_twin/twin': 'Digital Twin',
  'things/connectivity_dashboard': 'Connectivity Dashboard',
  'maintenance': 'Maintenance Management',
  'secrets': 'Secrets Manager',
  'use_case': 'Use Case Management',
  'grafana_dashboards': 'Grafana Dashboards',
};

export const ALL_ACCESSES_TYPES = ['read', 'create', 'update', 'delete', 'approver'];

export const USER_ROLE_ACCESS_CONTROL_DATA =[
  { id: 1, object_name: 'site/levels', access: { read: 0, create: 0, update: 0 } },
  { id: 2, object_name: 'things/services', access: { read: 0, create: 0, update: 0, delete: 0 } },
  {
    id: 3,
    object_name: 'things/components',
    access: {
      read: 0,
      create: 0,
      update: 0,
      delete: 0,
    },
    dependency: ['things/services'],
  },
  { id: 4, object_name: 'site/master', access: { read: 0, create: 0, update: 0 }, dependency: ['site/levels'] },
  {
    id: 5,
    object_name: 'things/machines',
    access: { read: 0, create: 0, update: 0, delete: 0 },
    route_id: 'things_machines',
  },
  {
    id: 6,
    object_name: 'things/machinesbulk',
    access: { read: 0, create: 0, update: 0, delete: 0 },
    dependency: ['things/machines'],
  },
  {
    id: 7,
    object_name: 'things/parts',
    access: { read: 0, create: 0, update: 0, delete: 0 },
    dependency: ['things/machines'],
    route_id: 'things_parts',
  },
  {
    id: 8,
    object_name: 'things/partsbulk',
    access: { read: 0, create: 0, update: 0, delete: 0 },
    dependency: ['things/machines'],
  },
  {
    id: 9,
    object_name: 'things/gateways',
    access: {
      read: 0,
      create: 0,
      delete: 0,
    },
    route_id: 'things_gateways',
    dependency: ['site/levels', 'site/master'],
  },
  {
    id: 10,
    object_name: 'site/factory',
    access: { read: 0, create: 0, update: 0, delete: 0, approver: 0 },
    route_id: 'site_factory',
    dependency: [
      'site/levels',
      'site/master',
      'things/components',
      'things/gateways',
      'things/machines',
      'things/services',
    ],
  },
  {
    id: 11,
    object_name: 'build_deploy/use_cases',
    access: { read: 0, create: 0, update: 0, delete: 0, approver: 0 },
    dependency: [
      'site/levels',
      'site/master',
      'site/factory',
      'things/components',
      'things/gateways',
      'things/machines',
      'things/services',
    ],
  },
  {
    id: 12,
    object_name: 'auth/users',
    access: { read: 0, create: 0, update: 0, delete: 0 },
    dependency: ['auth/roles'],
  },
  {
    id: 13,
    object_name: 'auth/roles',
    access: { read: 0, create: 0, update: 0, delete: 0 },
    dependency: ['auth/users'],
  },
  {
    id: 14,
    object_name: 'tenant/settings',
    access: { read: 0, create: 0, update: 0, delete: 0 },
  },
  {
    id: 15,
    object_name: 'digital_twin/twin',
    access: { read: 0, create: 0, update: 0, delete: 0 },
    dependency: ['site/levels', 'site/master'],
  },
  {
    id: 16,
    object_name: 'things/connectivity_dashboard',
    access: { read: 0 },
    dependency: ['things/gateways', 'site/levels', 'site/master'],
  },
  {
    id: 17,
    object_name: 'maintenance',
    access: { read: 0, create: 0, update: 0, delete: 0 },
    dependency: ['site/levels', 'site/master', 'things/machines'],
  },
  { id: 18, object_name: 'secrets', access: { read: 0, create: 0, update: 0, delete: 0 } },
  {
    id: 19,
    object_name: 'use_case',
    access: { read: 0, create: 0, update: 0, delete: 0 },
    dependency: ['site/levels', 'site/master', 'site/factory', 'things/gateways'],
  },
  {
    id: 20,
    object_name: 'grafana_dashboards',
    access: { read: 0, create: 0, update: 0, delete: 0 },
    dependency: ['site/levels', 'site/master'],
  },
]

export const CONNECTIVITY_DASHBOARD_API_PATHS = [
  process.env.REACT_APP_API_THINGS_ASSETS,
  process.env.REACT_APP_API_THINGS_EMQX,
  process.env.REACT_APP_API_THINGS_INFLUX,
  process.env.REACT_APP_API_THINGS_UI,
  process.env.REACT_APP_API_THINGS_BACKEND,
  process.env.REACT_APP_API_THINGS_NOTIFICATIONS,
];

export const DIGITAL_TWIN_API_PATHS = [
  process.env.REACT_APP_API_DIGITAL_TWIN,
  process.env.REACT_APP_API_DIGITAL_TWIN_SERVICE,
];

var pluralize = require('pluralize');

export const getFeatureLabel = (settingsData: any, route: { route_id: any; object_name: string; }) => {
  const getLabel = (routeId: string, routeName: string, routePath: string = '') => get(settingsData, `config.${routeId}.${routeName}`, DEFAULT_FEATURE_TITLES[routePath])

  if (route.object_name === 'things/machinesbulk') {
    return getLabel('things_machines', 'page_name', 'things/machines') + ' / ' + getLabel(route.route_id, 'page_name', route.object_name)
  }
  if (route.object_name === 'things/parts') {
    return getLabel('things_machines', 'page_name', 'things/machines') + ' / ' + `${pluralize(getLabel(route.route_id, 'entity_name', route.object_name))}`
  }
  if (route.object_name === 'things/partsbulk') {
    return getLabel('things_machines', 'page_name', 'things/machines') + ' / ' + `${pluralize(getLabel('things_parts', 'entity_name', 'things/parts'))}` + ' / ' + getLabel(route.route_id, 'page_name', route.object_name)
  }
  return getLabel(route.route_id, 'page_name', route.object_name)
}